function ProfileCard({ img, name, description }) {
    return (
        <div className="flex flex-col items-center border rounded-2xl shadow-2xl p-12">
            <img src={img} alt="img_st_4" className='w-32 h-32 object-cover rounded-full' />
            <h2 className='text-2xl font-bold text-center mt-5 text-tertiary'>{name}</h2>
            <p className='text-center mt-4'>{description}</p>
        </div>
    )
}

export default ProfileCard;